import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { LabelsGateway } from '@wilson/labels';
import { Observable, map } from 'rxjs';
import { BaseSelectFilterDirective } from '../../base-select-filter.directive';
import { FilterService } from '../../filter.service';
import { LabelFilterOptions } from '../../options.interface';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';

@Component({
  selector: 'wilson-user-labels-filter',
  templateUrl: './user-labels-filter.component.html',
  styleUrls: ['./user-labels-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserLabelFilterComponent extends BaseSelectFilterDirective<
  LabelFilterOptions,
  string[]
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService = inject(MultiSelectParserService);
  protected readonly labelsGateway = inject(LabelsGateway);

  @Input() showLabel = false;
  @Input() label: string | null = null;
  constructor() {
    super('userLabels');
  }

  protected initializeOptions(): Observable<LabelFilterOptions[]> {
    return this.labelsGateway.getLabels().pipe(
      map((label) => {
        return label.map((label) => {
          return {
            id: label.id.toString(),
            name: label.name.toString(),
            colorCode: label.colorCode,
          };
        });
      }),
    );
  }
}
